<template>
    <td class="compare-table__column compare-table__column--product">
        ${{price}}
    </td>
</template>

<script>
export default {
    props : {
        price : {
            type: Number,
            required: true
        }
    }
}
</script>